// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.react-modal-overlay.habit-delete-stop-tracking-modal .react-modal {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: auto;
  padding: 24px 20px;
}
.react-modal-overlay.habit-delete-stop-tracking-modal .react-modal .modal-top-buttons {
  display: none;
}
.react-modal-overlay.habit-delete-stop-tracking-modal .react-modal-content {
  width: 100%;
  display: flex;
  padding: unset;
  flex-direction: column;
}

.habit-modal-message {
  font-family: "Raleway";
  font-weight: 600;
  font-size: 16px;
  color: rgb(51, 51, 51);
  margin-bottom: 25px;
  text-align: center;
}

.habit-confirmation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
}

.habit-confirmation-icon {
  margin-right: 10px;
  height: 24px;
  width: 24px;
}

.habit-confirmation-title {
  font-family: "Raleway";
  font-weight: 600;
  font-size: 20px;
  color: rgb(51, 51, 51);
}

.habit-delete-stop-tracking-action-buttons {
  display: flex;
  justify-content: center;
  bottom: 24px;
}

.cancel-button,
.save-button {
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  color: rgb(51, 51, 51);
}

.cancel-button {
  margin-right: 12px;
}

.save-button {
  border-radius: 2rem;
  background: transparent;
  border: 0.1rem solid #b8b8b8;
  box-shadow: 0 0 1rem #c0c0c0;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Habits/HabitModalDeleteStopTracking.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAAE;EACE,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,YAAA;EACA,kBAAA;AAGJ;AADI;EACE,aAAA;AAGN;AAAI;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;AAEN;;AAGA;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBDFa;ECGb,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBDxBa;ACwBf;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AAAF;;AAGA;;EAEE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBDzCa;ACyCf;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,4BAAA;AAAF","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n.react-modal-overlay.habit-delete-stop-tracking-modal {\n  .react-modal {\n    display: flex;\n    width: fit-content;\n    height: fit-content;\n    margin: auto;\n    padding: 24px 20px;\n\n    .modal-top-buttons {\n      display: none;\n    }\n\n    &-content {\n      width: 100%;\n      display: flex;\n      padding: unset;\n      flex-direction: column;\n    }\n  }\n}\n\n.habit-modal-message {\n  font-family: 'Raleway';\n  font-weight: 600;\n  font-size: 16px;\n  color: $habitPrimary;\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.habit-confirmation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.habit-confirmation-icon {\n  margin-right: 10px;\n  height: 24px;\n  width: 24px;\n}\n\n.habit-confirmation-title {\n  font-family: 'Raleway';\n  font-weight: 600;\n  font-size: 20px;\n  color: $habitPrimary;\n}\n\n.habit-delete-stop-tracking-action-buttons {\n  display: flex;\n  justify-content: center;\n  bottom: 24px;\n}\n\n.cancel-button,\n.save-button {\n  padding: 10px 16px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  color: $habitPrimary;\n}\n\n.cancel-button {\n  margin-right: 12px;\n}\n\n.save-button {\n  border-radius: 2rem;\n  background: transparent;\n  border: 0.1rem solid #b8b8b8;\n  box-shadow: 0 0 1rem #c0c0c0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
